import React from "react";
import i18n from "~/assets/js/Helpers/i18n";
import Popup from "~/assets/js/components/Popup";
import Tabs from "~/assets/js/components/Tabs";
import Button from "~/assets/js/components/Button";
import PropTypes, { bool } from "prop-types";
import CurrentProduct from "./CurrentProduct";

const NutrientsPopup = ({ open, handleClose, tabs, isMainDish, product }) => {
    const popupConfig = {
        title: i18n.t("nutrients.mobile.title"),
        customStyle: "nutrients-mobile",
        open: open,
        draggable: true,
        handleClose: handleClose,
    };

    return (
        <Popup {...popupConfig}>
            <div>
                {isMainDish ? (
                    <Tabs tabs={tabs} />
                ) : (
                    <CurrentProduct product={product} />
                )}
            </div>

            <Button
                onClick={handleClose}
                label={i18n.t("nutrients.mobile.close")}
                variant="secondary"
            />
        </Popup>
    );
};

const tabType = {
    title: PropTypes.string,
    icon: PropTypes.element,
    content: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
};
const attributeType = {
    id: PropTypes.number,
    name: PropTypes.string,
    slug: PropTypes.string,
};

const productType = {
    attributes: PropTypes.arrayOf(PropTypes.shape(attributeType)),
    content: PropTypes.string,
    image: PropTypes.string,
    intolerance: PropTypes.arrayOf(PropTypes.shape(attributeType)),
    priceGross: PropTypes.string,
    priceNet: PropTypes.string,
    taxRate: PropTypes.string,
    title: PropTypes.string,
};

NutrientsPopup.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    tabs: PropTypes.arrayOf(PropTypes.shape(tabType)),
    isMainDish: bool,
    product: PropTypes.shape(productType),
};

export default NutrientsPopup;
